import { styled } from '@mui/material'

export const Wrapper = styled('div')(() => ({
  marginBottom: 2
}))

export const ChargeSession = styled('div')(() => ({
  width: 'auto',

  padding: 12,
  border: '1px solid #EDEBEB',
  borderRadius: '5px'
}))

export const Separator = styled('div')(() => ({
  width: '1fr',
  flexGrow: '1',
  borderTop: '0.5px dashed #CBCBCB',
  alignSelf: 'center',
  marginTop: '2px'
}))
